import { ref } from "vue";

const sortBy = ref("featured"); // estado global

export function useSort() {

  function setSort(value) {
    sortBy.value = value;
  }

  function sortProducts(products = []) {
    const list = [...products];

    switch (sortBy.value) {

      // 🔥 OFERTAS PRIMERO
      case "offers_first":
        return list.sort((a, b) => {
          const aPromo = a.tags?.some(t => t.startsWith("promo-")) ? 1 : 0;
          const bPromo = b.tags?.some(t => t.startsWith("promo-")) ? 1 : 0;
          return bPromo - aPromo; // promos arriba
        });

      case "price_asc":
        return list.sort((a, b) => a.price - b.price);

      case "price_desc":
        return list.sort((a, b) => b.price - a.price);

      case "az":
        return list.sort((a, b) =>
          a.title.localeCompare(b.title, "es", { sensitivity: "base" })
        );

      case "za":
        return list.sort((a, b) =>
          b.title.localeCompare(a.title, "es", { sensitivity: "base" })
        );

      default:
        return list; // destacados / original
    }
  }

  return {
    sortBy,
    setSort,
    sortProducts
  };
}
